import React, { useState } from "react"
import { Grid, Typography, useTheme, Slider } from "@mui/material"
import { makeStyles } from "@material-ui/core"
import AppTextField from "components/StyledComponents/AppTextField"
import { useDispatch, useSelector } from "react-redux"
import Edit from "@mui/icons-material/EditRounded"
import DoneIcon from "@mui/icons-material/DoneRounded"
import ClearIcon from "@mui/icons-material/ClearRounded"
import { DMVActions } from "redux/DMV/slice/user"
import { UpdatePromptAction } from "redux/DMV/actions/user"

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiSlider-thumb": {
      color: "var(--status-negative, #CC4B37)"
    },
    "& .MuiSlider-mark": {
      display: "none"
    }
  }
}))

const GenerateQuestions = ({ noOfQuestion, setNoOfQuestions }) => {
  const theme = useTheme()
  const sliderClass = useStyles()
  const { prompt, VIPRestaurant } = useSelector((store) => store?.dmv)
  const [editPrompt, setEditPrompt] = useState(false)
  const [localPrompt, setLocalPrompt] = useState(prompt)
  const dispatch = useDispatch()

  const handleQuestionCount = (event) => {
    setNoOfQuestions(event.target.value)
  }

  const handleSave = () => {
    dispatch(DMVActions.setPrompt(localPrompt))
    const payload = {
      restaurant: VIPRestaurant,
      quiz_prompt: localPrompt
    }
    dispatch(UpdatePromptAction(payload))
    setEditPrompt(false)
  }

  const handleCancel = () => {
    setLocalPrompt(prompt)
    setEditPrompt(false)
  }

  function valuetext(value) {
    return `${value}`
  }
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h2Italic" color={theme.palette.text.secondary}>
          Step-4
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body1Regular" color={theme.palette.text.secondary}>
          Number of questions
        </Typography>
      </Grid>
      <Grid item xs={3} ml={1}>
        <Slider
          className={sliderClass.root}
          aria-label="Always visible"
          defaultValue={1}
          getAriaValueText={valuetext}
          step={1}
          marks={marks}
          valueLabelDisplay="off"
          color="secondary"
          min={1}
          max={5}
          value={noOfQuestion}
          onChange={handleQuestionCount}
        />
      </Grid>
      <Grid xs={12} container item justifyContent={"space-between"} alignItems={"center"}>
        <Grid xs={6} container gap={2}>
          <Typography variant="body1Medium">Prompt</Typography>
          <Edit onClick={() => setEditPrompt(true)} />
        </Grid>
        {editPrompt && (
          <Grid xs={6} container gap={2} justifyContent={"flex-end"}>
            <DoneIcon color="success" onClick={handleSave} />
            <ClearIcon color="error" onClick={handleCancel} />
          </Grid>
        )}
      </Grid>
      <Grid xs={12} ml={2} mt={1}>
        <AppTextField
          value={editPrompt ? localPrompt : prompt}
          placeholder={"Prompt to generate questions"}
          fullWidth
          isDisabled={!editPrompt}
          onChange={(e) => setLocalPrompt(e.target.value)}
        />
      </Grid>
    </Grid>
  )
}

const marks = [
  {
    value: 1,
    label: "1"
  },
  {
    value: 2,
    label: "2"
  },
  {
    value: 3,
    label: "3"
  },
  {
    value: 4,
    label: "4"
  },
  {
    value: 5,
    label: "5"
  }
]
export default GenerateQuestions
